module.exports = __webpack_public_path__ + "static/lk-1226e4c0109c74026b50f4809a1f7da6.png";